<script>
	import { createEventDispatcher } from "svelte";

	const dispatch = createEventDispatcher();

	export let box_id = 0;
	export let result = undefined;
	export let result_for_idx = 0;
	export let num_particles;

	let direction = 0;
	let particle_idx = 0;

	function nextParticle() {
		particle_idx = (particle_idx + 1) % num_particles;
	}

	let audio = new Audio("/click.mp3");

	function measure() {
		audio.play();
		dispatch("measure", {
			particle_idx,
			box_id,
			direction: (direction * Math.PI) / 180,
		});
	}
</script>

<div class="main">
	<h2>Quantum Box</h2>
	<div>
		<p style="margin: 0;">Direction</p>
		<input
			type="range"
			min="0"
			max="360"
			step="15"
			bind:value={direction}
		/>
		<div>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 300 300"
				style="transform-origin: center; transform: rotate({270 +
					direction}deg);"
			>
				<defs>
					<marker
						id="arrowhead"
						markerWidth="5"
						markerHeight="7"
						refX="0"
						refY="2"
						orient="auto"
					>
						<polygon points="0 0, 5 2, 0 4" />
					</marker>
				</defs>
				<line
					x1="5"
					y1="150"
					x2="260"
					y2="150"
					stroke="#000"
					stroke-width="8"
					marker-end="url(#arrowhead)"
				/>
			</svg>
		</div>
		<div class="measurement">
			<button on:click={measure}>Measure</button>
			<div
				id="result"
				class="res{result_for_idx == particle_idx ? result : ''}"
			>
				{result_for_idx == particle_idx ? result ?? "??" : "??"}
			</div>
		</div>
	</div>

	<p>
		Particle #{particle_idx + 1}
	</p>

	<button on:click={nextParticle}> Next Particle </button>
</div>

<style>
	.measurement {
		display: flex;
		align-content: space-between;
		align-items: center;
		gap: 10px;
	}

	button {
		margin: 0;
	}

	#result {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 1.5em;
	}

	#result.res1 {
		background-color: orange;
	}

	#result.res0 {
		background-color: darkgrey;
	}

	.main {
		border: 2px black solid;
		padding: 20px;
	}

	h2 {
		margin-top: 0;
	}

	input {
		width: 100%;
		padding: 0;
	}
</style>
